import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { MessagesCounters } from './messages-counters-http-client';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<MessagesCounters>()(
  'MessagesCounters',
  {
    customActions: adapter => ({
      fetch: (state, payload: { candidateId: number }) => adapter.markAsPending(state),
    }),
  },
);

export {
  actions as MessagesCountersActions,
  reducer as MessagesCountersReducer,
  selectors as MessagesCountersSelectors,
  namespace as MessagesCountersNamespace,
};
